<template>
 <div class="shopping-cart">
     <hr/>
     <div v-if="product_info" class="margin-top-50 pretty-banner">
        <h5 style="font-size:18px;">Same product but different variations</h5>
        <p >if this product has different colours, sizes, etc... no need filling this long form again, go to this product view and set them.</p>
        <p class="center"><i class="fa fa-arrow-right"></i><a :href="product_url">Proceed to this Product's View </a></p>
     </div>
    <div v-if="!product_info" class="cart-ship-info register col-sm-10 contact_form">
       
        <h6  v-if="newGallery">New Product Lookbook</h6>
        <p v-else style="font-sixe:14px; font-weight:bold;">Adding to new product post to {{existing_gallery.gallery_posts_group_name}}</p>
            <form>
                <ul class="row" v-if="newGallery">
                 
                    <li class="col-sm-12">
                        <label> *Name
                            <input type="text" v-model="gallery.gallery_name" value="" placeholder="Gallery Name">
                        </label>
                    </li>
                    
                   <!-- <li class="col-sm-12">
                        <label> *Category 
                            <input type="text" v-model="gallery.gallery_name" value="" placeholder="Gallery Name">
                        </label>
                    </li> -->

                    <li class="col-md-12">
                          <label> *Description
                            <textarea  v-model="gallery.gallery_description"></textarea>
                          </label>
                    </li>
                   
                </ul>
                
                <h6 style="font-size:16px;">Add Products</h6>
                <div>
                    <div v-if="products.length && (products.length != 0)">
                        <p><b>Select from your Products/Services to add to Gallery</b></p>
                        <div class="col-xs-12">
                            <div class="col-xs-3" v-for="(p,pdex) in products" :key="pdex" style="padding:5px; margin:1em; width:10%">
                                <a :title="p.product_name" style="cursor:pointer;" @click="setComponent('add-to-gallery-product',p)">
                                    <div class="box-color-cube" v-if="p.product_images[0]">
                                        <img :src="p.product_images[0].product_image" :id="p.product_id+'PRD'" class="product-select sp-prd-img" style="height:4em; width:85%;"/>
                                    </div>
                                    <p style="font-size:8px;"><b>{{p.product_name}}</b></p>
                                </a> 
                            </div>
                        </div>
                    </div>
                    <p v-else class="p-tiny-info">You do not have any products yet</p>
                    <div>
                        <button type="button" class="btn" @click="setComponent('show-add-product-form','')">
                            <b><span v-if="products.length && (products.length != 0)"> Or </span> Add New Product / Service</b>
                        </button>
                    </div>

                    <!--product-form-->
                    <div v-if="showProductForm">
                        <div class="cart-ship-info register col-sm-10  contact_form">
                            <h6>Add Product / Service</h6>
                            <form>
                                <ul class="">
                                    <li class="col-sm-6 product-type">
                                        <label class="line-wrap"> Product
                                            <input class="sp-radio-btn" type="radio" v-model="is_product_service" value="product" style="height:20px;">
                                        </label>
                                    </li>
                                    <li class="col-sm-6 product-type">
                                    <label> Service
                                            <input class="sp-radio-btn" type="radio" v-model="is_product_service" value="service" style="height:20px;">
                                        </label>
                                    </li>
                                    <li class="col-sm-12">
                                        <label> *Name
                                            <input type="text" v-model="product.product_name" value="" placeholder="">
                                        </label>
                                    </li>
                                    
                                    <li class="col-md-4" v-if="sellpoint_categories.length > 0">
                                        <label> Select Product Category
                                        <select v-model="product.product_category" id="category-type-1" v-on:change="trackevent('category-type-1')">
                                            <option value="0" :disabled="category_type_1">Select</option>
                                            <option :disabled="category_type_1" v-for="category in sellpoint_categories" :key="category.business_category_id" :value="category.business_category_id">{{category.business_category}}</option>
                                        </select>
                                        </label>
                                    </li>

                                    <!-- <li class="col-sm-1" v-if="sellpoint_categories.length != 0">
                                        <label><b> *Or </b></label>
                                    </li> -->

                                    <li class="col-md-4" v-if="sub_categories.length > 0">
                                        <label><span v-if="sellpoint_categories.length > 0"><b>Or </b></span> Select from Shop Categories
                                        <select v-model="product.product_sub_category" class="category-type-2" v-on:change="trackevent('category-type-2')">
                                            <option value="0" :disabled="category_type_2">Select</option>
                                            <option :disabled="category_type_2" v-for="category in sub_categories" :key="category.sub_category_id" :value="category.sub_category_id">{{category.sub_category_name}}</option>
                                        </select>
                                        </label>
                                    </li>
                                
                                    <li class="col-md-4">
                                        <label> 
                                            <span v-if="(sellpoint_categories.length > 0) || (sub_categories.length > 0)">
                                                <b>Or </b> Enter a specific Category
                                            </span>
                                            <span v-else style="text-transform: capitalize;">
                                               Enter {{is_product_service}} Category
                                            </span>
                                            <input :disabled="category_type_3" type="text" v-model="product.product_listed_category" placeholder="" id="category-type-3" v-on:change="trackevent('category-type-3')">
                                        </label>
                                    </li>

                                    <li class="col-md-12">
                                        <label> *Description
                                            <textarea  v-model="product.product_description"></textarea>
                                        </label>
                                    </li>
                                    <!-- <h6>Add a product Item, you can add more items later</h6> -->
                                    
                                    <li class="col-md-4">
                                        <label> *Price
                                            <input type="number" v-model="product.product_item_price" placeholder="" required>
                                        </label>
                                    </li>
                                    <!-- <li class="col-md-12">
                                        <label> More Information</label>
                                    </li> -->

                                    <li class="col-md-4" v-if="is_product_service == 'product'">
                                        <label> *Weight(Kg)
                                            <input type="number" v-model="product.product_item_weight"  step="any" placeholder="" required>
                                        </label>
                                    </li>

                                    <li class="col-md-4">
                                        <label> *Quantity
                                            <input type="number" v-model="product.product_item_quantity"  placeholder="" required>
                                        </label>
                                    </li>
                                    
                                    <li class="col-md-12">
                                        <p class="p-tiny-info">{{max_media_info}}</p>
                                        <div class="upload-btn-wrapper" style="cursor:pointer">
                                            <!-- <img class="img_responsive"/> -->
                                            <button type="button" class="upload-btn">Add <span style="text-transform: capitalize;">{{is_product_service}}</span> Image / Video</button>
                                            <input type="file" id="input-file" @change="onFileChange($event)" accept="video/*,image/*" capture/>
                                            <span v-if="file_info[0]"><b>Added {{file_info[0].name}}</b></span>                                                                                                                                                                                                                                                                                                                                        
                                        </div>
                                        <p class="data-error-message">{{data_media_error_message}}</p>
                                    </li>
                                    <li class="col-md-6">
                                        <p class="data-error-message">{{data_error_message}}</p>
                                        <p class="data-success-message">{{data_success_message}}</p>
                                        <div v-if="action_loading" class="loading-sm"></div>
                                        <button :disabled="disable_btn" type="button" class="pull-left btn" @click="addProduct">Add {{is_product_service}}</button>
                                        <button type="button" class="pull-right btn" @click="reset">Cancel</button>
                                    </li>
                                </ul>
                            </form>
                        </div>
                    </div>
                    <div>
                        <li class="col-md-6" v-if="canAddGallery">
                            <p class="data-error-message">{{data_error_message}}</p>
                            <p class="data-success-message">{{data_success_message}}</p>
                            <div v-if="action_loading" class="loading-sm"></div>
                            <button :disabled="disable_btn" type="button" class="btn" @click="addGallery">Add Lookbook</button>
                        </li>
                    </div>
                    <!---./-product-form--->
                </div>   
              
        </form>
        </div>
    </div>
</template>
<style>
.pretty-banner{
   border: 1px solid #b3b9c0;
   padding: 1.2em;
   background: #83ee91;
   line-height: 1.8;
   border-radius: 5px;
   color:#fff; 
}
.pretty-banner p a:hover{
    color: #ff0000;
}
  /*form*/
  .contact_form li {
	text-align: left;
	margin-bottom: 10px;
}
.contact_form li input {
	display: inline-block;
	width: 100%;
	height: 35px;
	padding: 0 10px;
	margin-top: 5px;
}
.contact_form li .error {
	border: 1px solid #CCC;
	border-bottom: 1px solid red;
}
.contact_form li .form-control {
	height: 45px;
	border: 1px solid #2d3a4b;
	box-shadow: none;
	border-radius: 0px;
	background: #fff;
}
.contact_form li textarea {
	height: 140px !important;
	width: 340px;
	margin-top: 10px;
}
.contact_form li .btn {
	text-transform: uppercase;
	padding: 0px 40px;
	height: 45px;
	line-height: 45px;
	font-size: 14px;
	margin-top: 15px;
}
.contact_form li .btn:hover {
	background: #ffffff;
}
.contact-form .tittle {
	text-align: center;
}
.contact-form .tittle hr {
	width: 28px;
	height: 5px;
	margin: 15px auto;
	background: #448aff;
	border: none;
}
.contact-form .tittle p {
	text-transform: none;
	font-size: 16px;
}
.contact-form label {
	font-weight: normal;
	color: #2d3a4b;
	font-size: 12px;
	text-transform: uppercase;
	display: inline-block;
	width: 100%;
	margin: 0px;
	margin-bottom: 13px;
}
.contact-form textarea {
	display: inline-block;
	width: 100%;
	position: relative;
	padding: 10px 20px;
}

</style>

<script>
import services from './../../services/service'; // Service Class
let service = new services();

export default {
    name: 'ProductForm',
    data () {
        return {
            user:{},
            sellpoint: {},
            sellpoint_categories: {},
            sub_categories: {},
            products:{},
            product:{},
            post:{},
            gallery:{},
            selected_produts:[],
            product_item: {},
            disable_btn: false,
            imageForm: "",
            product_info: false,
            product_url: "",
            category_type_1: false,
            category_type_2: false,
            category_type_3: false,
            file_info: {},
            showProductForm:false,
            canAddGallery:true,
            is_product_service: "product",
            existing_gallery:{},
            newGallery:true,
            action_loading:false,
            data_error_message:"",
            data_success_message:"",
            data_media_error_message:"",
            max_media_info:service.max_upload_image_info,
        
        }
    },
    components: {
       
     },
    methods: {
        activate_processing(){
            this.disable_btn = true;
            this.action_loading = true;
        },

        deactivate_processing(){
            this.disable_btn = false;
            this.action_loading = false;
        },

        setComponent(attr1,attr2){
            if(attr1 == "add-to-gallery-product"){
                //check if previously added
                let if_index = this.selected_produts.indexOf(attr2.product_id);
                if(if_index != -1){ //added
                    //remove from array
                    this.selected_produts.splice(if_index);
                    document.getElementById(attr2.product_id+"PRD").style.border = "none"; //unstyle
                }else{
                    this.selected_produts.push(attr2.product_id);
                    document.getElementById(attr2.product_id+"PRD").style.border = "1px solid #0000CC";
                }
               
            }
            if(attr1 == "show-add-product-form"){
                // this.showProductForm = true;
                // this.canAddGallery = false;
                if(this.showProductForm){
                    this.showProductForm = false;
                    this.canAddGallery = true;
                }else{
                    this.showProductForm = true;
                    this.canAddGallery = false;
                }
            }
        },

        reset(){
            this.showProductForm = false;
            this.canAddGallery = true;
        },
        
        trackevent(e){
            // $('#category-type-3').disabled = true;
            if(e == "category-type-1" && this.product.product_category != 0 && this.product.product_category != undefined){
              this.category_type_2 = true;
              this.category_type_3 = true;
            }
            else if(e == "category-type-2" && this.product.product_sub_category != 0 && this.product.product_sub_category != undefined){
              this.category_type_1 = true;
              this.category_type_3 = true;
            }
            else if(e == "category-type-3" && this.product.product_listed_category != "" && this.product.product_listed_category != undefined){
              this.category_type_1 = true;
              this.category_type_2 = true; 
            }
            else{
            this.category_type_1 = false;
              this.category_type_2 = false;
              this.category_type_3 = false;
             }
        },

        preset() {
            var credentials = {
                session_key: localStorage.getItem("sp_token")
            } 
            if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            this.user.user_id = element.user_id;
                        }, this);
                        //get sellpoint categories
                        this.getSellpointCategories();
                        //checking routes for an existing gallery
                        if(this.$route.params.idg != undefined){
                            this.newGallery = false;
                            this.setGallery();
                        }
                        //checking routes for an existing gallery
                    }else {
                        this.$router.push('login');
                      }
                }).catch((err) => {
                    if(err) {
                        this.$router.push('login');
                    }
                })
            }else {
                this.$router.push('login');
            }
        },

        getSellpointCategories(){
            service.getBusinessByUserName(this, this.$route.params.id).then(response => {
                if(response.body.status == 200) {
                   this.sellpoint = response.body.data;
                   //let sellpoint_data = response.body.data;
                    service.getBusinessCategories(this, this.sellpoint.business_id).then(response => {
                        if(response.body.status == 200) {
                            this.sellpoint_categories = response.body.data;
                        }
                    }).catch((err) => {})
                    this.getSubCategories(this.sellpoint.business_category_id);
                    this.getSellpointProducts();
                }
            }).catch((err) => {
                //log it
               // this.$router.push("/")
               //console.log(err)
            })

        },

        getSubCategories(category){
            service.getBusinessSubCategories(this, category).then(response => {
                if(response.body.status == 200) {
                    this.sub_categories = response.body.data;
                }
            }).catch((err) => {})
                
        },

        getSellpointProducts(){
            service.getBusinessProducts(this, this.sellpoint.business_id).then(response => {
                if(response.body.status == 200) {
                    this.products = response.body.data;
                }
            }).catch((err) => {})
                
        },

        addGallery(){
            // this.disable_btn = true;
            //first deactivate any initiall processing
            this.deactivate_processing();
            //then activate another processing
            this.activate_processing();
            let gallery_new_group = true;
            let gallery_post_group = 0; //no group as in new
            if(!this.newGallery){
                gallery_post_group = this.existing_gallery.gallery_posts_group_id; 
                gallery_new_group = false;
            }
           
            var credentials = {
                gallery_new_group:  gallery_new_group,
                gallery_group_type: 2, //product gallery
                gallery_group_point: this.sellpoint.business_id,
                gallery_group_name: this.gallery.gallery_name,
                gallery_group_description:this.gallery.gallery_description,
                gallery_post_group: gallery_post_group,
                gallery_post_caption: this.post.post_caption || "nill",
                gallery_post_details: this.post.post_details || "nill",
                gallery_post_products: this.selected_produts || [], 
            }
          
            let navi = this.$router;
            if(credentials.gallery_post_details != undefined) {
                service.addGallery(this, credentials).then(function(data) {
                    if(data.body.status == 201) {
                        // toastr.success("Post Created", 'Success!');
                        this.data_success_message = "Post Created"; 
                        //log user in
                        this.gallery = data.body.data;
                        if(this.newGallery){
                            location.replace("/"+this.$route.params.id+"/g/"+this.gallery.gallery_posts_group_url_name); //changed for now, info on banner
                        }else{
                            location.reload(); //just reload current gallery page
                        }
                    }
                    this.deactivate_processing();
                }).catch((err) => {
                    if(err) {
                        // toastr.warning("Something went wrong", 'Warning!'); 
                        this.data_error_message = "Something went wrong"; 
                        // console.log(err)
                        // this.disable_btn = false;
                        this.deactivate_processing();
                    }
                })
            }else {
                toastr.error('Kindly fill all fields', 'Warning!');
                this.disable_btn = false;
            }
        },

        addProduct(){
            // this.disable_btn = true;
            this.activate_processing();
            //this.business.agree = true;
            var credentials = {
                product_name: this.product.product_name,
                product_is_product_or_service: this.is_product_service,
                product_category: this.product.product_category || 0,
                product_sub_category: this.product.product_sub_category || 0,
                product_listed_category: this.product.product_listed_category || "nill",
                product_business: this.sellpoint.business_id,
                product_description: this.product.product_description || "nill",
                product_item_price: this.product.product_item_price,
                product_item_weight: this.product.product_item_weight || 1,
                product_item_quantity: this.product.product_item_quantity || 1
            }
            
            let navi = this.$router;
            if(credentials.product_name != undefined) {
                service.addProduct(this, credentials).then(function(data) {
                    if(data.body.status == 201) {
                        // toastr.success("Product Added Successfully", 'Success!');
                        this.data_success_message = "Product Added Successfully"; 
                        //log user in
                        this.product = data.body.data;
                        
                        //add image
                        //let result = data.body.data;
                        // this.imageForm.append("data_id", this.product.product_item_id); //refac
                        this.imageForm.append("data_id", this.product.product_id);
                        // this.imageForm.append("data_type","product_items"); //refac
                        this.imageForm.append("data_type","products");
                        service.uploadDataPhoto(this, this.imageForm).then(data => {
                        if(data.body.status == 200){
                            
                            //1. add products,show products, add to selevted products array

                            //     //call get products to refresh list
                            //     this.getSellpointProducts();
                            //     //add this new product to selected_products array
                            //     this.selected_produts.push(this.product.product_id);
                            //    // this.setComponent("add-to-gallery-product",this.product);
                            //     //remove form
                            //     this.showProductForm = false;
                            //     //bring back add gallery button
                            //     this.canAddGallery = true;
                            
                            //2. addproducts, add to selected products array and add gallery
                            this.data_media_error_message = "";
                            this.selected_produts.push(this.product.product_id);
                            this.addGallery();
                            
                        }
                        }).catch((err) => {
                                if(err) {
                                // log it
                                //console.log(err)
                                }
                            // toastr.warning("Something went wrong.", 'Warning!');
                            this.data_error_message = "Something went wrong"; 
                        })
                        //if uploading takes time continue with reload
                        this.data_media_error_message = service.media_upload_timeout_msg;
                        let self = this;
                        setTimeout(function(){  self.data_media_error_message; }, 1200); //wait for 1min and timeout
                        setTimeout(function(){ 
                            //1-2. addproducts, add to selected products array and add gallery
                            self.selected_produts.push(self.product.product_id);
                            self.addGallery();
                        }, 2000);//wait for 1min and timeout

                        //navi.push("/"+this.$route.params.id+"/"+this.product.product_url_name); //changed for now, info on banner

                        
                    }
                }).catch((err) => {
                    if(err) {
                        // toastr.warning("Something went wrong", 'Warning!'); 
                        this.data_error_message = "Something went wrong";
                       // console.log(err)
                        this.disable_btn = false;
                    }
                })
            }else {
                // toastr.error('Kindly fill all fields', 'Warning!');
                this.data_error_message = "Kindly fill all fields";
                this.disable_btn = false;
            }
        },


        setGallery(){
            this.loading = true;
            service.getGallerySearch(this, this.$route.params.idg).then(response => {
                if(response.body.status == 200) {
                    this.existing_gallery = response.body.data;
                    //this.loading = false;
                }
            }).catch((err) => {})
        },
     
    //uploads
    onFileChange(e) {
        let files = e.target.files || e.dataTransfer.files;
        if (files.length)
        {   
            this.file_info = files;
            let formData = new FormData();
            formData.append('photo', files[0]); 
            this.imageForm = formData;
        }   
       
    },

},
    created: function(){
       this.preset();
    }
}

</script>


// WEBPACK FOOTER //
// newproductgallery.vue?693af247